// 电子面单账号
import httpClient from "../../http/mainServerClient";
import EwaybillAccountDTO from "@/dto/ewaybillAccount/EwaybillAccountDTO";
import LogisticsCompany from "@/enum/LogisticsCompany";
import EwaybillType from "@/enum/EwaybillType";
import ShippingAddressDTO from "@/dto/ewaybillAccount/ShippingAddressDTO";
import BranchAccountDTO from "@/dto/ewaybillAccount/BranchAccountDTO";
import SubscriptionDTO from "@/dto/ewaybillAccount/SubscriptionDTO";
import { cloneDeep } from "lodash";
import WaybillTemplateType from "@/enum/WaybillTemplateType";

/** 在原来接口数据基础上过滤仅获取对当前店铺可见店铺对应的ewaybillAccount */
export async function getAllowedEwaybillAccountList(types: EwaybillType[] = []) {
    return httpClient.get<EwaybillAccountDTO[]>("/ewaybillAccount/list_allowed", {
        joinedTypes: types.join(","),
    });
}

/**
 * 缓存，因为电子面单账号极少会发生变化
 * 电子面单账号关联关系：分4级，一个电子面单账号可能会包含多个快递公司，一个快递公司可能包含多个网点，一个网点可能包含多个发货地址
 * EwaybillAccount -> EwaybillSubscriptions-> EwaybillBranchAccount -> EwaybillShippingAddress
 */
export async function getEwaybillAccountList(types: EwaybillType[] = []) {
    return httpClient.get<EwaybillAccountDTO[]>("/ewaybillAccount/list", {
        joinedTypes: types.join(","),
    });
}

/**
 * @deprecated
 * TODO: 全部改使用 /store/EwaybillAccountStore
 * 考虑缓存，因为电子面单账号极少会发生变化
 * 电子面单账号关联关系：分4级，一个电子面单账号可能会包含多个快递公司，一个快递公司可能包含多个网点，一个网点可能包含多个发货地址
 * EwaybillAccount -> EwaybillSubscriptions-> EwaybillBranchAccount -> EwaybillShippingAddress
 */
export async function list(types: EwaybillType[] = [], logisticsCompany?: LogisticsCompany) {
    const ewaybillAccounts = await httpClient.get<EwaybillAccountDTO[]>(
        `/ewaybillAccount/list?joinedTypes=${types.join(",")}`,
    );

    if (logisticsCompany) {
        ewaybillAccounts.forEach((ewaybillAccount) => {
            const subscriptions = ewaybillAccount.subscriptions;

            ewaybillAccount.subscriptions = subscriptions.filter((it) => it.logisticsCompany === logisticsCompany);
        });
    }

    ewaybillAccounts.forEach((ewaybillAccount) => {
        ewaybillAccount.subscriptions.forEach((subscription) => {
            // @ts-ignore
            subscription.ewaybillAccount = ewaybillAccount;

            subscription.branchAccounts.forEach((branchAccount) => {
                // @ts-ignore
                branchAccount.subscription = subscription;

                branchAccount.shippingAddresses.forEach((shippingAddress) => {
                    // @ts-ignore
                    shippingAddress.branchAccount = branchAccount;
                });
            });
        });
    });

    return ewaybillAccounts;
}

/**
 * @deprecated
 * TODO: 全部改使用 /store/EwaybillAccountStore
 */
export async function loadEwaybillAccountsList(types: EwaybillType[] = [], logisticsCompany?: LogisticsCompany) {
    const rawEwaybillAccounts = await getEwaybillAccountList(types);

    if (logisticsCompany) {
        rawEwaybillAccounts.forEach((ewaybillAccount) => {
            const subscriptions = ewaybillAccount.subscriptions;

            ewaybillAccount.subscriptions = subscriptions.filter((it) => it.logisticsCompany === logisticsCompany);
        });
    }

    const ewaybillShippingAddressMapping = new Map<number, ShippingAddressDTO>();
    const branchAccountMapping = new Map<number, BranchAccountDTO>();
    const subscriptionMapping = new Map<number, SubscriptionDTO>();
    const ewaybillAccountMapping = new Map<number, EwaybillAccountDTO>();
    const ewaybillAccountId2AccountMapping = new Map<number, EwaybillAccountDTO>();
    const branchAccountIdToBranchAccountMap = new Map<number, BranchAccountDTO>();

    rawEwaybillAccounts.forEach((account) => {
        ewaybillAccountId2AccountMapping.set(account.id, account);
        account.subscriptions.forEach((subscription) => {
            subscription.branchAccounts.forEach((branchAccount) => {
                branchAccountIdToBranchAccountMap.set(branchAccount.id, branchAccount);

                branchAccount.shippingAddresses.forEach((shippingAddress) => {
                    ewaybillShippingAddressMapping.set(shippingAddress.id, shippingAddress);

                    branchAccountMapping.set(shippingAddress.id, branchAccount);

                    subscriptionMapping.set(shippingAddress.id, subscription);

                    ewaybillAccountMapping.set(shippingAddress.id, account);
                });
            });
        });
    });

    const processedEwaybillAccounts = cloneDeep(rawEwaybillAccounts);

    processedEwaybillAccounts.forEach((ewaybillAccount) => {
        ewaybillAccount.subscriptions.forEach((subscription) => {
            // @ts-ignore
            subscription.ewaybillAccount = ewaybillAccount;

            subscription.branchAccounts.forEach((branchAccount) => {
                // @ts-ignore
                branchAccount.subscription = subscription;

                branchAccount.shippingAddresses.forEach((shippingAddress) => {
                    // @ts-ignore
                    shippingAddress.branchAccount = branchAccount;
                });
            });
        });
    });

    return {
        ewaybillShippingAddressMapping,
        branchAccountMapping,
        subscriptionMapping,
        ewaybillAccountMapping,
        rawEwaybillAccounts,
        processedEwaybillAccounts,
        branchAccountIdToBranchAccountMap,
        ewaybillAccountId2AccountMapping,
    };
}

export async function loadAllowedEwaybillAccountsList(types: EwaybillType[] = [], logisticsCompany?: LogisticsCompany) {
    const rawEwaybillAccounts = await getAllowedEwaybillAccountList(types);

    if (logisticsCompany) {
        rawEwaybillAccounts.forEach((ewaybillAccount) => {
            const subscriptions = ewaybillAccount.subscriptions;

            ewaybillAccount.subscriptions = subscriptions.filter((it) => it.logisticsCompany === logisticsCompany);
        });
    }

    const ewaybillShippingAddressMapping = new Map<number, ShippingAddressDTO>();
    const branchAccountMapping = new Map<number, BranchAccountDTO>();
    const subscriptionMapping = new Map<number, SubscriptionDTO>();
    const ewaybillAccountMapping = new Map<number, EwaybillAccountDTO>();
    const ewaybillAccountId2AccountMapping = new Map<number, EwaybillAccountDTO>();
    const branchAccountIdToBranchAccountMap = new Map<number, BranchAccountDTO>();

    rawEwaybillAccounts.forEach((account) => {
        ewaybillAccountId2AccountMapping.set(account.id, account);
        account.subscriptions.forEach((subscription) => {
            subscription.branchAccounts.forEach((branchAccount) => {
                branchAccountIdToBranchAccountMap.set(branchAccount.id, branchAccount);

                branchAccount.shippingAddresses.forEach((shippingAddress) => {
                    ewaybillShippingAddressMapping.set(shippingAddress.id, shippingAddress);

                    branchAccountMapping.set(shippingAddress.id, branchAccount);

                    subscriptionMapping.set(shippingAddress.id, subscription);

                    ewaybillAccountMapping.set(shippingAddress.id, account);
                });
            });
        });
    });

    const processedEwaybillAccounts = cloneDeep(rawEwaybillAccounts);

    processedEwaybillAccounts.forEach((ewaybillAccount) => {
        ewaybillAccount.subscriptions.forEach((subscription) => {
            // @ts-ignore
            subscription.ewaybillAccount = ewaybillAccount;

            subscription.branchAccounts.forEach((branchAccount) => {
                // @ts-ignore
                branchAccount.subscription = subscription;

                branchAccount.shippingAddresses.forEach((shippingAddress) => {
                    // @ts-ignore
                    shippingAddress.branchAccount = branchAccount;
                });
            });
        });
    });

    return {
        ewaybillShippingAddressMapping,
        branchAccountMapping,
        subscriptionMapping,
        ewaybillAccountMapping,
        rawEwaybillAccounts,
        processedEwaybillAccounts,
        branchAccountIdToBranchAccountMap,
        ewaybillAccountId2AccountMapping,
    };
}

interface CreateOfficialEwaybillAccountParams {
    logisticsCompany: LogisticsCompany;

    username?: string | number;

    password?: string | number;

    branchName?: string | number;

    branchCode?: string | number;

    extraInfoJson?: Record<string, string | number>;
}

export function createOfficialEwaybillAccount({
    logisticsCompany,
    username,
    password,
    branchName,
    branchCode,
    extraInfoJson,
}: CreateOfficialEwaybillAccountParams): Promise<EwaybillAccountDTO> {
    return httpClient.post("/ewaybillAccount/createOfficialEwaybillAccount", {
        logisticsCompany,
        username,
        password,
        branchName,
        branchCode,
        extraInfoJson: extraInfoJson ? JSON.stringify(extraInfoJson) : undefined,
    });
}

export function getServiceOptions({ logisticsCompany, type }) {
    return httpClient.get(`/ewaybillAccount/serviceOptions`, {
        logisticsCompany,
        type,
    });
}

export enum EwaybillAccountSyncErrorType {
    /** 店铺授权无效，需要重新进行店铺授权。 */
    SHOP_INVALID_ACCESS_TOKEN = "SHOP_INVALID_ACCESS_TOKEN",

    /** 电子面单账号授权无效，需要重新进行电子面单账号授权。 */
    EWAYBILL_ACCOUNT_INVALID_ACCESS_TOKEN = "EWAYBILL_ACCOUNT_INVALID_ACCESS_TOKEN",

    NO_ACCOUNT = "NO_ACCOUNT",

    OTHER = "OTHER",
}

export interface EwaybillAccountSyncResult {
    errorMessage?: string;

    errorType?: EwaybillAccountSyncErrorType;

    ewaybillType: EwaybillType;

    ewaybillAccountId?: number;

    /** 如果是店铺授权,该值代表店铺的id */
    shopId?: number;

    successful: boolean;
}

interface SyncEwaybillAccountParams {
    waybillTemplateType?: WaybillTemplateType;
    ewaybillShippingAddressId?: number;
}

export async function syncEwaybillAccount(params?: SyncEwaybillAccountParams): Promise<EwaybillAccountSyncResult[]> {
    const rawResult = await httpClient.get<Promise<EwaybillAccountSyncResult[]>>(`/ewaybillAccount/sync`, params);

    const result = [];

    let index = 0;

    rawResult.forEach((ewaybillAccountSyncResult) => {
        if (ewaybillAccountSyncResult.successful === false) {
            result.splice(index++, 0, ewaybillAccountSyncResult);
        } else {
            result.push(ewaybillAccountSyncResult);
        }
    });

    return result;
}

export interface CreateShareEwaybillAccountParams {
    /**用户备注 */
    remarkName: string;

    /**共享码 */
    shareCode: string;
}

/**创建电子面单共享账号 */
export function createShareEwaybillAccount(params: CreateShareEwaybillAccountParams) {
    return httpClient.get<{ redirectUrl: string }>("/sharedEwaybillAccount/auth", params);
}

export function deleteEwaybillAccount(id): Promise<void> {
    return httpClient.post(`/ewaybillAccount/delete/${id}`);
}

export interface UpdateEwaybillAccountQuantityPostData {
    /**
     * 获取成功的电子面单数量，不能为空！
     */
    allocatedQuantity: number;
    /**
     * 待更新电子面单账号订购id，不能为空
     */
    ewaybillSubscriptionId: number;
    /**
     * 待更新电子面单网点账号id，不能为空
     */
    ewaybillBranchAccountId: number;

    /**
     * 待更新电子面单发货地址 ID，不能为空
     */
    ewaybillShippingAddressId: number;
}

interface UpdateEwaybillAccountQuantityResult {
    /**
     * 获取成功的电子面单数量，不能为空！
     */
    quantity: number;

    /**
     * 待更新电子面单发货地址 ID，不能为空
     */
    ewaybillShippingAddressId: number;
}

/**
 * 更新电子面单网点账号可用单号
 */
export function batchUpdateEwaybillAccountQuantity(data: UpdateEwaybillAccountQuantityPostData[]) {
    return httpClient.post<UpdateEwaybillAccountQuantityResult[]>("/ewaybillAccount/batchUpdateQuantity", data, {
        hideModal: true,
    });
}

interface ApplyChannelShopEwaybillAuthParams {
    shopId: number;
    ewaybillShopSellerUsername: string;
}

/**
 * 申请使用微信小店的电子面单
 */
export function applyChannelShopEwaybillAuth(params: ApplyChannelShopEwaybillAuthParams) {
    return httpClient.post("/channel_shop_ewaybill_auth_apply_record/apply", params);
}

export enum ApproveChannelShopEwaybillAuthStatus {
    /**
     * 提交审核
     */
    APPLIED = "APPLIED",
    /**
     * 通过
     */
    APPROVED = "APPROVED",
    /**
     * 拒绝
     */
    REJECTED = "REJECTED",
    /**
     * 过期
     */
    EXPIRED = "EXPIRED",
}

interface ApproveChannelShopEwaybillAuthParams {
    shopId: number;
    recordId: number;
    status: ApproveChannelShopEwaybillAuthStatus;
}

/**
 * 审核微信小店
 */
export function approveChannelShopEwaybillAuth(params: ApproveChannelShopEwaybillAuthParams) {
    return httpClient.post("/channel_shop_ewaybill_auth_apply_record/approve", params);
}

export interface ChannelShopEwaybillAuthApplyRecord {
    id: number;
    dateCreated: string;
    lastUpdated: string;
    applicantShopId: number;
    /**
     * 申请人店铺名称
     */
    applicantShopName: string;
    ewaybillShopSellerUsername: string;
    applicant: string;
    processor: string;
    status: ApproveChannelShopEwaybillAuthStatus;
    /**
     * 渠道
     */
    applyChannel: "ES" | "FHY";
}

/**
 * 审核微信小店
 */
export function getChannelShopEwaybillAuthRecordList(shopId: number) {
    return httpClient.get<ChannelShopEwaybillAuthApplyRecord[]>("/channel_shop_ewaybill_auth_apply_record/list", {
        shopId,
    });
}

export function createAiKuCunEwaybillAccount(appId: string, appSecret: string) {
    return httpClient.post("/ewaybill_account/create_aikucun_ewaybill_account", { appId, appSecret });
}

/** 更新电子面单账号名称 */
export function updateEwaybillAccountName(id: number, name: string): Promise<void> {
    return httpClient.post(`/ewaybill_account/update/${id}:name`, { name });
}

export interface EwaybillQuantityResultItem {
    /**
     * 网点编码
     */
    branchCode?: string;
    /**
     * 网点名称
     */
    branchName?: string;
    /**
     * 电子面单账号名称
     */
    ewaybillAccountName?: string;
    /**
     * 网点账号 ID
     */
    ewaybillBranchAccountId?: number;
    /**
     * 电子面单类型名称
     */
    ewaybillType?: EwaybillType;
    /**
     * 快递公司名称
     */
    logisticsCompany?: LogisticsCompany;
    /**
     * 当前余额
     */
    quantity?: number;
}

export interface EwaybillQuantityAlertResult {
    /**
     * 预警列表
     */
    alerts?: EwaybillQuantityResultItem[];

    noAlerts?: EwaybillQuantityResultItem[];

    /**
     * 预警阈
     */
    threshold?: number;
}

/** 查询触发预警的电子面单账号列表。 */
export function getEwaybillAccountQuantityAlerts() {
    return httpClient.get<EwaybillQuantityAlertResult>(`/ewaybill_account/quantity_alerts`, null, { hideModal: true });
}

/** 设置网点账号预警开关 */
export function setBranchAccountAlert(ewaybillBranchAccountId: number, enabled: boolean) {
    return httpClient.post(`/ewaybillAccount/set_branch_account_alert/${ewaybillBranchAccountId}/${enabled}`);
}

const ewaybillAccountApi = {
    getEwaybillAccountList,
    list,
    createOfficialEwaybillAccount,
    getServiceOptions,
    syncEwaybillAccount,
    createShareEwaybillAccount,
};

export default ewaybillAccountApi;
